/**
 * Class names for the element Mux takes fullscreen. Must not use
 * overflow-hidden — clipping the fullscreen host causes a black viewport.
 *
 * @returns Tailwind classes for the fullscreen host wrapper
 */
export const videoFullscreenHostClassName = (): string => {
	return "h-full w-full bg-black";
};

/**
 * Page chrome around the video player. Rounding stays on laptop; do not clip
 * with overflow-hidden so the fullscreen host can expand cleanly.
 *
 * @returns Tailwind classes for the /videos/[slug] player chrome
 */
export const videoPagePlayerChromeClassName = (): string => {
	return "fixed laptop:relative laptop:top-auto top-[6.55rem] right-0 left-0 z-10 laptop:m-0 flex aspect-[16/9] items-center laptop:rounded-2xl laptop:border laptop:bg-black pt-0 shadow-xl";
};
